module.exports = __webpack_public_path__ + "img/symbol_5.5f2120f2.png";